import { configureStore } from "@reduxjs/toolkit";

import currentUserSlice from "./slices/currentUserSlice";
import authSlice from "./slices/authSlice";
import notificationListSlice from "./slices/notificationSlice";
import settingsSlice from "./slices/settingsSlice";
import commonModalSlice from "./slices/commonModalSlice";
import currentClusterSlice from "./slices/currentClusterSlice";
import clusterListSlice from "./slices/clusterListSlice";
import applicationSlice from "./slices/applicationSlice";
import citySlice from "./slices/citySlice";
import cartSlice from "./slices/cartSlice";
import complexOrderCartSlice from "./slices/complexOrderCartSlice";

import { cartCacheMiddleware } from "./middleware/cartCacheMiddleware";
import { complexOrderCartCacheMiddleware } from "./middleware/complexOrderCartCacheMiddleware";
import { cityCacheMiddleware } from "./middleware/cityCacheMiddleware";

import { getFromStorage } from "../common/utils/functions/localStorage";
import {
  CartItem,
  CityInterface,
  ComplexOrderCartState,
} from "../common/types/interfaces";

const cartItems = getFromStorage<CartItem[]>("cart") ?? [];
const cartCutlery = getFromStorage<Record<number, number>>("cartCutlery") ?? {};
const complexOrderCart =
  getFromStorage<ComplexOrderCartState>("complexOrderCart");
const city = getFromStorage<CityInterface>("city");

const preloadedState = {
  cart: {
    items: cartItems,
    total: cartItems.reduce((sum, i) => sum + i.price * i.quantity, 0),
    cutleryByCluster: cartCutlery,
  },
  complexOrderCart: complexOrderCart ?? {
    items: [],
    isOpen: false,
    total: 0,
    phone: "",
    comment: "",
    fieldValues: [],
  },
  city: { city: city ?? undefined },
};

export const store = configureStore({
  reducer: {
    currentUser: currentUserSlice,
    auth: authSlice,
    notificationList: notificationListSlice,
    settings: settingsSlice,
    commonModal: commonModalSlice,
    currentCluster: currentClusterSlice,
    clusterList: clusterListSlice,
    application: applicationSlice,
    city: citySlice,
    cart: cartSlice,
    complexOrderCart: complexOrderCartSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      cartCacheMiddleware,
      complexOrderCartCacheMiddleware,
      cityCacheMiddleware,
    ),
  preloadedState,
});

export type RootState = ReturnType<typeof store.getState>;
